// Theme registry. Add a theme by writing a ThemeDefinition module and
// listing it here — Settings → Appearance, the no-flash CSS generation,
// and `applyTheme` all read from this one list.

import type { ThemeDefinition } from "./types";
import { glass } from "./glass";
import { earth } from "./earth";
import { midnight } from "./midnight";

// Order = display order in the picker. First entry is the default.
export const THEMES: ThemeDefinition[] = [glass, earth, midnight];

export const DEFAULT_THEME = THEMES[0];

export type ThemeName = (typeof THEMES)[number]["name"];

const BY_NAME: Record<string, ThemeDefinition> = Object.fromEntries(
  THEMES.map((t) => [t.name, t]),
);

export function getTheme(name: string | null | undefined): ThemeDefinition {
  return (name && BY_NAME[name]) || DEFAULT_THEME;
}

export function isThemeName(name: string | null | undefined): name is ThemeName {
  return !!name && name in BY_NAME;
}

export type { ThemeDefinition } from "./types";
